module.exports = __webpack_public_path__ + "img/Slide7.41c4c405.png";